module.exports = __webpack_public_path__ + "img/gradient-right.7045f1b8.png";